<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h4 class="page-title text-center">Perfiles Productivos Asociados al Motor | <b class="" [style]="{'color': color }">{{datos_perfil.nombre_perfil}}</b></h4>
      </div>
    </div>
  </div>

  <img [src]="url + iconos" alt="" class="icon" />

  <div class="row mt-4" style="margin-bottom: 500px;">

    <ng-container *ngFor="let pf of perfilesList">

      <div class="col-md-3 mt-3 mb-3">
        <div class="card text-center h-100 shadow-lg" [style]="'border-color: '+ color +''">
          <div class="card-header text-white" [style]="'background-color: '+ color +''">
            <p class="card-title">{{pf.nombre_oferta_formativa}}</p>
          </div>
          <div class="card-body">
            <p class="card-text sinopsis" style="text-align: justify;">{{pf.sinopsis | slice:0:300}}...</p>
            <div class="row">
              <div class="col-md-8 text-start">
                <p class="subtitles2">
                  <b class="sinopsis" [style]="{'color': color }">Perfil Productivo:</b>
                  {{pf.nombre_oferta_formativa}}
                </p>
              </div>
              <div class="col-md-4 mt-4 text-end">
                <p class="sinopsis hrs">{{pf.horas}} Hrs</p>
              </div>
            </div>

          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-md-12">
                <a class="btn btn-primary" [style]="'background: '+color+' !important; border-color: '+color+' !important;'" (click)="informacion(content, pf)">
                  Formaciones
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </ng-container>

  </div>

  <app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

  <ng-template #content let-modal>
    <div class="modal-header text-white" [style]="'background-color: '+ color +''">
      <h4 class="modal-title">{{nombre_perfil}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-8 h4 text-center" [style]="'color: '+ color +''">Plan de Estudio (UC)</div>
        <div class="col-md-4 h4 text-center" [style]="'color: '+ color +''">Horas </div>
        <hr [style]="'color: '+color+'; height: 10px; background-color: '+color+'; '">
        <div class="col-12" *ngFor="let of of ofertasList, let i=index">
          <div class="form-check form-checkbox-info mb-2">
            <!--div class="row puntero"-->
            <div class="row">
              <div class="col-md-8 mt-1">{{of.unidad_curricular}}</div>
              <div class="col-md-4 mt-1 text-center">{{of.hora_uc}} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <a type="button" [style]="'background:'+color+' !important; border-color:'+color+' !important;'" class="btn btn-lg btn-secondary" (click)="modal.close('Close click')">
        Cerrar
      </a>
    </div>
  </ng-template>



</div>





